export default __webpack_public_path__ + "static/media/flag-taiwan.0ce91b48.svg";